import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { OrdersPage } from '@/features/service-agreements/orders-page';

/** The used-car service-agreement orders. The list endpoint requires `service-agreement:read`. */
export const Route = createFileRoute('/_app/service-agreement/orders/used-car')({
  staticData: { featureKey: 'service-agreements' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'service-agreements',
      permissions: ['service-agreement:read'],
    }),
  component: () => <OrdersPage type="USED_CAR" />,
});
